// changeOrderSetup.ts — Patch 016.1.Q Phase 2.A.
//
// CO template upload + AI-parse API client. Mirrors drawSetup.ts for
// draw_templates. Backend: workers/core-os/src/routes/change_order_setup.ts
// (migration 0091 + 0092).

import { ApiError, BASE, request } from './request'

const pid = (id: string): string => encodeURIComponent(id)

export interface ChangeOrderTemplate {
  id: string
  project_id: string
  document_id: string | null
  parse_pdf_document_id: string | null
  parse_status: string
  parsed_field_map_json: string | null
  parse_error: string | null
  parsed_at: string | null
  created_at: string
  updated_at: string | null
  fill_filename: string | null
  fill_mime_type: string | null
  parse_pdf_filename: string | null
  parse_pdf_mime_type: string | null
}

export const changeOrderSetupApi = {
  /**
   * Upload either the .doc/.docx fillable template OR the saved-as-PDF for
   * AI parsing. Backend routes the file to the right column based on its
   * extension. Subsequent uploads update the existing row's matching slot.
   */
  upload: async (projectId: string, file: File) => {
    const form = new FormData()
    form.append('file', file)
    const res = await fetch(
      `${BASE}/api/projects/${pid(projectId)}/change-order-template`,
      { method: 'POST', credentials: 'include', body: form },
    )
    const body = (await res.json().catch(() => null)) as unknown
    if (!res.ok) {
      const err = (body as { error?: string })?.error ?? `http_${res.status}`
      throw new ApiError(err, res.status, body)
    }
    return body as {
      ok: true
      template_id: string
      document_id: string
      role: 'parse_pdf' | 'fill'
      request_id: string
    }
  },
  get: (projectId: string) =>
    request<{ ok: true; template: ChangeOrderTemplate | null }>(
      `/api/projects/${pid(projectId)}/change-order-template`,
    ),
  parse: (projectId: string, templateId: string) =>
    request<{
      ok: boolean
      template_id?: string
      parse_status?: string
      field_count?: number
      error?: string
      detail?: string
    }>(
      `/api/projects/${pid(projectId)}/change-order-template/${pid(templateId)}/parse`,
      { method: 'POST', body: '{}' },
    ),
}
